import React from 'react';
interface LogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  variant?: 'full' | 'icon';
}
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/nNfWnyTPw3cN5ZzXvCJeAx/Dizajn_bez_naslova_(1).png';
export const Logo = ({
  size = 'md'
}: LogoProps) => {
  const frameClass = size === 'sm' ? 'h-10 w-20' : size === 'xl' ? 'h-28 w-44' : size === 'lg' ? 'h-20 w-32' : 'h-14 w-24';
  return <span className={`relative block shrink-0 overflow-hidden ${frameClass}`} data-id="element-133" data-mp="mte0v260xnic">
      <img src={LOGO_URL} alt="JumpLand" className="h-full w-full object-cover object-[center_60%] transition-transform duration-300 group-hover:scale-105" data-id="element-134" data-mp="rqw5whgx7il2" />
    </span>;
};